import axios from "axios";
import storage from "./storage.js";
axios.defaults.baseURL = "/";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      storage.purgeSessionData();
      return window.location.assign(`${window.origin}/users/sign_in`);
    }
    return Promise.reject(error);
  }
);

window.axios = axios;

let instance = null;
class AxiosConfigurator {
  constructor(store) {
    if (!instance) {
      instance = this;
    }
    this.store = store;
    this.subscribeForSessionChange();
    this.loadLocalStorageToken();
    return instance;
  }

  loadLocalStorageToken = () => {
    const { session } = storage.getSessionData();
    this.token = session.token;
    this.updateToken();
  };

  subscribeForSessionChange = () => {
    this.store.subscribe((state) => {
      const token = this.store.getState().session.token;
      if (this.token != token) {
        this.token = token;
        this.updateToken();
      }
    });
  };

  updateToken = () => {
    if (this.token) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Token token=${this.token}`;
    } else {
      axios.defaults.headers.common["Authorization"] = null;
    }
  };

  configureAxios = () => {
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response;
      },
      function (error) {
        // Do something with response error
        return Promise.reject(error);
      }
    );
  };
}

export default AxiosConfigurator;



// WEBPACK FOOTER //
// ./src/services/axios_config.js